module.exports = __webpack_public_path__ + "fonts/56122e2.otf";